import { GuarantorEntityType } from "@/lib/supabase/supabaseTypes";
import {
	getClientDisplayName,
} from "@/lib/utils/client-utils";

export function getGuarantorDisplayName(guarantor: GuarantorEntityType | null | undefined, lastNameFirst?: boolean): string {
	return getClientDisplayName(guarantor as any, lastNameFirst);
}
